import { Component, OnInit, OnDestroy, DoCheck, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { PaymentFailPage } from 'src/app/shared/modals/payment-fail/payment-fail.page';
import { PaymentSuccessPage } from 'src/app/shared/modals/payment-success/payment-success.page';
import { CountdownEvent, CountdownComponent, CountdownConfig } from 'ngx-countdown';
import { AlertService, AuthenticationService, GlobalService } from 'src/app/shared/_services';
import { Location } from '@angular/common';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { PaymentsStore } from 'src/app/shared/_services/store/paymentsStore.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.page.html',
  styleUrls: ['./confirm.page.scss'],
  providers: [CountdownComponent, Clipboard],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmPage implements OnInit, OnDestroy, DoCheck {
  @ViewChild(CountdownComponent, { static: false }) counter: CountdownComponent;
  amount = this.paymentsStore.getAmount();
  paymentMethod = this.paymentsStore.getPaymentMethod();
  bankTransferDetails = this.paymentsStore.getBankTransferDetails();
  ussdDetails = this.paymentsStore.getUssdDetails();
  bankTransferPayment = true;
  ussdPayment = true;
  bankTransferResponse: any;
  ussdResponse: any;
  bankTransferExpiryDate: any;
  ussdExpiryDate: any;
  bankTransferCountdown: CountdownConfig;
  ussdCountdown: CountdownConfig;
  virtualAccountNumber: any;
  accountName: any;
  ussdString: any;
  getTransactionStatus: any;
  stopTimer: any;
  subscription: any;
  loading = true;
  hide = false;
  error = false;
  cordova: boolean;
  errorText: string;

  constructor(
    private modalController: ModalController, private platform: Platform, private clipboard: Clipboard,
    private location: Location, private alertService: AlertService, private auth: AuthenticationService,
    private globalService: GlobalService, private paymentsStore: PaymentsStore) {
    if (this.paymentMethod === 'bankTransfer') {
      this.bankTransferPayment = false;
      this.virtualAccountNumber = this.bankTransferDetails.virtualAccount;
      this.accountName = this.bankTransferDetails.accountName;
      this.bankTransferCountdown = {
        stopTime: this.bankTransferDetails.expiryDate, format: 'mm:ss'
      };
    } else {
      this.ussdPayment = false;
      // this.accountName = localStorage.getItem('demoAccountName');
      this.ussdString = this.ussdDetails.ussdString;
      this.ussdCountdown = {
        stopTime: this.ussdDetails.expiryDate, format: 'mm:ss'
      };
    }
  }

  copyAccountNo(detail: string) {
    if (this.paymentMethod === 'bankTransfer') {
      const virtualAccount = document.getElementById('virtual-account');
      detail = virtualAccount.textContent.replace('Copy', '\n').replace(')', ')\n');
      this.copyToClipboard(detail, 'Account Number');
    } else {
      const ussdCode = document.getElementById('ussd-code');
      detail = ussdCode.textContent.replace('Copy', '\n');
      this.copyToClipboard(detail, 'USSD Code');
    }
  }

  copyDetails(detail: string) {
    if (this.paymentMethod === 'bankTransfer') {
      const bankTransferTextDetails = document.getElementById('bank-transfer-details');
      detail = bankTransferTextDetails.textContent.replace('Copy', '\n').replace(')', ')\n');
      detail = detail.replace('Account No', `${'Amount: ' + this.amount + '\n' + 'Account No'}`);
      this.copyToClipboard(detail, 'bank details');
    } else {
      const ussdTextDetails = document.getElementById('ussd-details');
      detail = ussdTextDetails.textContent.replace('Copy', '\n');
      this.copyToClipboard(detail, 'USSD details');
    }
  }

  copyToClipboard(detail: string, text: string) {
    console.log(detail);
    if (this.platform.is('cordova')) {
      this.clipboard.copy(detail)
        .then(() => {
          this.copiedAlert(text);
        })
        .catch(() => {
          this.alertService.standardToast('Unable to copy details. Please manually select and copy', 'bottom');
        }
      );
    } else {
      navigator.clipboard.writeText(detail);
      this.copiedAlert(text);
    }
  }

  copiedAlert(text: string) {
    this.alertService.standardToast('Copied ' + text, 'bottom');
  }

  cancel() {
    this.alertService.cancelTransactionAlert();
  }

  removeItems() {
    this.paymentsStore.removeAmount();
  }

  async success() {
    const modal = await this.modalController.create({
      component: PaymentSuccessPage,
      cssClass: 'bottom-modal h-50',
      backdropDismiss: false
    });
    return await modal.present();
  }

  async timeOut(e: CountdownEvent) {
    const modal = await this.modalController.create({
      component: PaymentFailPage,
      cssClass: 'bottom-modal h-50',
      backdropDismiss: false
    });
    this.removeItems();
    return await modal.present();
  }

  handleEvent(event: CountdownEvent) {
    if (event.action === 'done') {
      this.loading = false;
      this.timeOut(event);
      clearInterval(this.stopTimer);
      clearInterval(this.getTransactionStatus);
      console.log(event);
    } else {
      if (this.platform.is('ios')) {
        this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
          if (this.constructor.name === 'ConfirmPage') {
            this.alertService.checkForAlert();
          } else {
            this.location.back();
          }
        });
      }
    }
  }

  pauseTimer() {
    this.counter.pause();
    console.log('Pause');
  }
  alertTimerController() {
    this.loading = false;
    this.hide = true;
    this.success();
    this.pauseTimer();
    this.removeItems();
    clearInterval(this.stopTimer);
    clearInterval(this.getTransactionStatus);
    console.log('Payment Successful!');
  }

  ionViewWillEnter() {
    document.title = 'Confirm Demo Payment | Bank3D';
  }

  ionViewDidLeave() {
    this.removeItems();
    this.counter.stop();
    clearInterval(this.getTransactionStatus);
    clearInterval(this.stopTimer);
    this.paymentsStore.removeAmount();
  }

  ngOnInit() {
    this.errorText = this.globalService.errorText.oops + this.globalService.errorText.persists;
    this.cordova = this.platform.is('cordova');
    this.getTransactionStatus = setInterval(() => {
      if (this.paymentMethod === 'bankTransfer') {
        this.auth.confirmDemoBankTransferPayment(this.bankTransferDetails.virtualAccount)
        .subscribe(
          response => {
            this.error = false;
            console.log(response);
            this.paymentsStore.setBankTransferResponse(response);
            this.bankTransferResponse = this.paymentsStore.getBankTransferResponse();
          },
          error => {
            console.log(error.error);
            if (!error.error.message.includes('Transaction')) {
              this.error = true;
            }
          }
        );
      } else {
        this.auth.confirmDemoUssdPayment(this.ussdDetails.reference)
        .subscribe(
          response => {
            this.error = false;
            console.log(response);
            this.paymentsStore.setUssdResponse(response);
            this.ussdResponse = this.paymentsStore.getUssdResponse();
          },
          error => {
            this.error = true;
            console.log(error);
          }
        );
      }
    }, 4000);
    this.stopTimer = setInterval(() => {
      if (this.paymentMethod === 'bankTransfer' &&
      (this.bankTransferResponse ? this.bankTransferResponse.transactions[0].queryResponse === '00' : false)) {
        this.alertTimerController();
        console.log('Payment Successful!');
       } else if (this.paymentMethod === 'ussd' && this.ussdResponse.responseCode === '00') {
        this.alertTimerController();
       }
    }, 5000);
  }

  ionViewWillLeave() {
    if (this.platform.is('ios')) {
      this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
        if (this.constructor.name === 'ConfirmPage') {
          this.alertService.checkForAlert();
        } else {
          this.location.back();
        }
      });
    }
  }

  ngDoCheck(): void {
  }

  ngOnDestroy() {
    this.ionViewDidLeave();
  }
}
